import { FC } from "react"
import classNames from "classnames"
import "./index.scss"

interface RadioButtonProps {
   label: string
   name: string
   value: string
   checked: boolean
   onChange: (value: string) => void
   disabled?: boolean
   className?: string
   id?: string
   testId?: string
}

const RadioButton: FC<RadioButtonProps> = ({
   label,
   name,
   value,
   checked,
   onChange,
   disabled = false,
   className,
   id,
   testId,
}) => {
   return (
      <div
         className={classNames("radio-button", className, {
            ["radio-button--disabled"]: disabled,
         })}
      >
         <input
            type="radio"
            id={id}
            name={name}
            value={value}
            checked={checked}
            {...(!disabled && { onChange: () => onChange(value) })}
            disabled={disabled}
            className="radio-button__input"
            data-testid={testId}
         />
         <label
            htmlFor={id}
            className="radio-button__label"
         >
            <span className="radio-button__circle" />
            {label}
         </label>
      </div>
   )
}

export default RadioButton
